import React from 'react';
import { ArrowDown } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full bg-[#F5F0E6] text-[#333333] pt-8 pb-12 px-4 sm:pt-12 sm:pb-20 sm:px-6 md:pt-20 md:pb-28 overflow-hidden" data-id="element-77">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center" data-id="element-78">
        {/* Text Content */}
        <div className="z-10 order-2 lg:order-1" data-id="element-79">
          <span className="inline-block py-1 px-3 rounded-full bg-[#7C3AED]/15 text-[#6D28D9] text-xs sm:text-sm font-semibold tracking-wide mb-4 sm:mb-6" data-id="element-80">
            GUÍA DIGITAL • EBOOK
          </span>

          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight mb-4 sm:mb-6 text-[#4C1D95]" data-id="element-81">
            Sanar en <span className="text-[#84CC16] italic" data-id="element-82">Movimiento</span>
          </h1>

          <p className="text-lg sm:text-xl md:text-2xl text-[#555555] mb-6 sm:mb-8 font-serif italic leading-relaxed" data-id="element-83">
            Cómo acompañar la recuperación sin abandonar tu cuerpo.
          </p>

          <div className="space-y-4 sm:space-y-6 text-base sm:text-lg text-[#444444] leading-relaxed mb-8 sm:mb-10" data-id="element-84">
            <p data-id="element-85">Te pasa esto:</p>
            <p data-id="element-86">
              Un día te lesionas. Y de inmediato te dan dos opciones igual de
              malas:
            </p>
            <ul className="space-y-2 pl-4 border-l-2 border-[#7C3AED]/40" data-id="element-87">
              <li data-id="element-88">
                1) <strong data-id="element-89">Quédate quieto</strong> (hasta nuevo aviso).
              </li>
              <li data-id="element-90">
                2) <strong data-id="element-91">Sigue como si nada</strong> (hasta que te reviente).
              </li>
            </ul>
            <p data-id="element-92">
              Y tú quedas atrapado en el peor lugar: con dolor, con miedo… y con
              la sensación de que cada semana sin moverte te está robando algo.
            </p>
            <p className="font-medium text-[#4C1D95]" data-id="element-93">
              <em data-id="element-94">Sanar en Movimiento</em> es el punto medio que casi nadie sabe
              ejecutar.
            </p>
          </div>

          <a href="#offer" className="w-full sm:w-auto inline-flex items-center justify-center px-6 sm:px-8 py-4 text-base sm:text-lg font-bold text-white transition-all transform bg-[#7C3AED] rounded-lg hover:bg-[#6D28D9] active:scale-[0.98] shadow-lg hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#7C3AED]" data-id="element-95">
            Quiero recuperar el control
            <ArrowDown className="ml-2 w-5 h-5" data-id="element-96" />
          </a>
        </div>

        {/* Image */}
        <div className="relative order-1 lg:order-2 flex justify-center lg:justify-end" data-id="element-97">
          <div className="relative w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-full" data-id="element-98">
            <div className="absolute inset-0 bg-[#7C3AED] rounded-3xl transform rotate-3 opacity-20 blur-xl" data-id="element-99"></div>
            <img src="https://cdn.magicpatterns.com/uploads/iLprBbr3vnZoRSincCaa9E/heylloyd-image-1770185884355.png" alt="Sanar en Movimiento Ebook en teléfono" className="relative z-10 w-full h-auto rounded-2xl shadow-2xl transform -rotate-2" data-id="element-100" />
          </div>
        </div>
      </div>
    </section>;
}